import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from '../code-snippets/code-snippet.interface';



@Component({
    selector: 'custom-functions',
    template: '',
    standalone: false
})
export class CustomFunctionExample implements CodeSnippet{

    text : string = $localize`:@@script-editor.code-example.custom-function:custom function`;

    category: string = 'examples';

    data: any;

    part = false;

    insert(): string | Promise<string> {
        return `function main()

    local p = getplant()

    show(decoratePlant(p))
        
end

-- define your own function here
function decoratePlant(p)

    return frmt(
        "Plant: {0,-20} (ID: {1})",
        p.name,
        p.plantId
    )

end

`
    }
}